import React, { useEffect, useState } from "react";
import config from "../../../config";

const InventorySummaryCard = () => {
    const token = localStorage.getItem("token");
    const branchId = localStorage.getItem("branch_id");

    const [summary, setSummary] = useState({
        totalSkus: 0,
        inventoryValue: 0,
        lowStock: 0,
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchSummary = async () => {
            try {
                const res = await fetch(
                    `${config.apiUrl}/api/swalook/analytics/inventory/summary/?branch_name=${branchId}`,
                    {
                        headers: {
                            Authorization: `Token ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (!res.ok) throw new Error("API failed");

                const json = await res.json();

                // 🔍 LOG ONCE – remove later
                console.log("Inventory summary API response:", json);

                // ✅ Normalize response safely
                const data = json.data || json;

                setSummary({
                    totalSkus: data.total_skus ?? data.total_products ?? 0,
                    inventoryValue:
                        data.inventory_value ?? data.total_inventory_value ?? 0,
                    lowStock: data.low_stock_count ?? data.low_stock ?? 0,
                });
            } catch (err) {
                console.error("Inventory summary error:", err);
                setError(true);
            } finally {
                setLoading(false);
            }
        };

        fetchSummary();
    }, [token, branchId]);

    if (loading) {
        return (
            <div className="bg-white rounded-[2.5rem] shadow p-6 mb-4 animate-pulse h-[140px]" />
        );
    }

    if (error) {
        return (
            <div className="bg-white rounded-[2.5rem] shadow p-6 mb-4 text-red-600">
                Failed to load inventory summary
            </div>
        );
    }

    return (
        <div className="bg-white rounded-[2.5rem] shadow p-6 mb-4">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                {/* Total SKUs */}
                <div className="flex items-center gap-4 hover:bg-gray-50 rounded-xl p-3 transition">
                    <div className="bg-blue-100 p-3 rounded-xl">
                        <span className="text-4xl text-blue-600">📦</span>
                    </div>
                    <div>
                        <p className="text-sm text-gray-500">Total SKUs</p>
                        <p className="text-2xl font-bold text-gray-800">
                            {summary.totalSkus}
                        </p>
                        <p className="text-xs text-gray-400">Unique products</p>
                    </div>
                </div>

                {/* Inventory Value */}
                <div className="flex items-center gap-4 hover:bg-gray-50 rounded-xl p-3 transition">
                    <div className="bg-green-100 p-3 rounded-xl">
                        <span className="text-4xl text-green-600">💰</span>
                    </div>
                    <div>
                        <p className="text-sm text-gray-500">Inventory Value</p>
                        <p className="text-2xl font-bold text-gray-800">
                            ₹{Number(summary.inventoryValue).toLocaleString()}
                        </p>
                        <p className="text-xs text-gray-400">
                            Total capital locked
                        </p>
                    </div>
                </div>

                {/* Low Stock */}
                <div className="flex items-center gap-4 hover:bg-red-50 rounded-xl p-3 transition">
                    <div className="bg-red-100 p-3 rounded-xl">
                        <span className="text-4xl text-red-600">⚠️</span>
                    </div>
                    <div>
                        <p className="text-sm text-gray-500">
                            Low-stock Alerts
                        </p>
                        <p className="text-2xl font-bold text-gray-800">
                            {summary.lowStock}
                        </p>
                        <p className="text-xs text-red-500">Action required</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InventorySummaryCard;
